var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05848 11.2018V5.37121L0 3.79389L12.363 0L24.7128 3.85384L22.2734 4.5329V6.74948C22.2734 6.74948 22.7732 6.6996 22.9932 7.5283V19.2188H20.8937V7.52784C20.8937 7.52784 21.0637 6.84877 21.6236 6.68907V4.76216L19.6341 5.38128V10.8522C19.6341 10.8522 13.366 14.9358 8.37765 8.31627C8.37765 8.31673 6.30798 8.53637 5.05848 11.2018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3247 17.6504C13.8983 21.1006 10.6043 21.2288 7.45745 17.6504C3.58203 20.1598 1.77857 23.697 1.78911 28.1334H22.9628C22.8029 23.5208 20.9234 20.0262 17.3247 17.6504ZM12.3496 27.8039L8.02744 20.6453C10.701 23.1831 13.5643 23.379 16.6649 20.6453L12.3496 27.8039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.2dc0051f81a1e7edc9121d3f630b8d8d.svg";
export { ForwardRef as ReactComponent };